import {ReactNode} from 'react';

export function TableHeaderRow({children}: {children?: ReactNode}) {
  return <tr className={`bg-sw-background-component`}>{children}</tr>;
}
